import React from "react";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock";

const cardTones = [
  "bg-[#FEF3C7]",
  "bg-[#FCE7F3]",
  "bg-[#E0E7FF]",
  "bg-[#CFFAFE]",
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="section-light py-20 md:py-28 relative overflow-hidden">
      <div className="blob blob-pink w-96 h-96 -top-16 left-1/4" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-[#B45309] text-xs font-black tracking-[0.3em] uppercase">Success Stories</div>
          <h2 className="section-title mt-3 text-4xl md:text-5xl font-black brand-navy">
            What our learners say
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t, i) => (
            <div key={t.name} className={`rounded-3xl p-6 border border-[#0A1740]/8 ${cardTones[i % cardTones.length]} flex flex-col shadow-sm hover:shadow-lg transition-shadow`}>
              <Quote className="text-[#0A1740]/40" size={26} />
              <p className="mt-4 text-[#0A1740]/85 text-sm leading-relaxed flex-1 italic">“{t.quote}”</p>
              <div className="mt-5 flex items-center gap-1 text-[#F59E0B]">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <div className="mt-3">
                <div className="brand-navy font-extrabold">{t.name}</div>
                <div className="text-[#0A1740]/55 text-xs font-semibold">{t.course} Batch</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
